function resolveSampleCollectionGuidelinesUrl() {
  if (process.env.REACT_APP_SAMPLE_COLLECTION_GUIDELINES_URL) {
    return process.env.REACT_APP_SAMPLE_COLLECTION_GUIDELINES_URL;
  }

  const staticUrl = process.env.REACT_APP_STATIC_URL;
  if (staticUrl && staticUrl.startsWith('http')) {
    return `${staticUrl.replace(/\/$/, '')}/documents/sample-collection-guidelines.pdf`;
  }

  const apiBase = (process.env.REACT_APP_API_SERVER_URL || 'http://localhost:8000').replace(/\/$/, '');
  return `${apiBase}/sample-collection-guidelines.pdf`;
}

export const SAMPLE_COLLECTION_GUIDELINES_URL = resolveSampleCollectionGuidelinesUrl();
